import React from 'react';
import { User, MapPin } from 'lucide-react';

const StepIndicator = ({ currentStep, translations }) => (
  <div className="flex items-center justify-center mb-12">
    <div className="flex items-center">
      <div className="flex items-center text-white relative mr-16">
        <div className="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 bg-indigo-600 border-indigo-600 flex items-center justify-center">
          <User className="w-6 h-6" />
        </div>
        <div className="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-indigo-600">
          {translations("auth.signup.stepAccount")}
        </div>
      </div>
      <div className={`flex-auto border-t-2 transition duration-500 ease-in-out ${currentStep === 2 ? 'border-indigo-600' : 'border-gray-300'}`} />
      <div className="flex items-center text-white relative">
        <div className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${currentStep === 2 ? 'bg-indigo-600 border-indigo-600' : 'border-gray-300'} flex items-center justify-center`}>
          <MapPin className={`w-6 h-6 ${currentStep === 2 ? 'text-white' : 'text-gray-300'}`} />
        </div>
        <div className={`absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase ${currentStep === 2 ? 'text-indigo-600' : 'text-gray-500'}`}>
          {translations("auth.signup.stepDetails")}
        </div>
      </div>
    </div>
  </div>
);

export default StepIndicator;